import { ComponentMap } from '@cinch-nx/data-storyblok'
import { sharedStoryblokComponents } from '@cinch-nx/storyblok'

import {
  HelpMeChoose,
  HomeHeroV2,
  PartExchangeSection,
  UspSlide,
  ValuePropositions,
  WhyCinch,
} from '../components'

const localStoryblokComponents: ComponentMap = {
  HomeHeroV2: HomeHeroV2,
  HelpMeChooseSection: HelpMeChoose,
  WhyCinchSection: WhyCinch,
  PartExSection: PartExchangeSection,
  ValuePropsCard: ValuePropositions,
  HomeUspSlide: UspSlide,
}

export const storyblokComponents = {
  ...sharedStoryblokComponents,
  ...localStoryblokComponents,
}
